"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloseBtn = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const React = tslib_1.__importStar(require("react"));
const modal_1 = require("@nbc-design/modal");
require("./dialog.css");
/**
 * @ignore
 */
// eslint-disable-next-line react/display-name
exports.CloseBtn = React.forwardRef(({ children, appearance = 'link', ...other }, ref) => {
    return ((0, jsx_runtime_1.jsx)(modal_1.Modal.CloseBtn, { ...other, appearance: appearance, ref: ref, children: children }));
});
//# sourceMappingURL=closeBtn.js.map